import { createAction, handleActions } from 'redux-actions';
import { instanceUrl } from '../utils/article';
import { getSource, getGlobalId } from '../utils/knreise'; // ------------------------------------
// Constants
// ------------------------------------

export var COMMENTS_LOADING = 'COMMENTS_LOADING';
export var COMMENTS_LOADED = 'COMMENTS_LOADED';
export var COMMENT_PUBLISHING = 'COMMENT_PUBLISHING';
export var COMMENT_PUBLISHED = 'COMMENT_PUBLISHED';
export var COMMENT_PUBLISH_FAILED = 'COMMENT_PUBLISH_FAILED';
export var CLEAR_COMMENT_PUBLISH_ERROR = 'CLEAR_COMMENT_PUBLISH_ERROR';
export var COMMENT_FLAGGING = 'COMMENT_FLAGGING';
export var COMMENT_FLAGGED = 'COMMENT_FLAGGED';
export var COMMENT_FLAGGED_FAILED = 'COMMENT_FLAGGED_FAILED';
export var SET_USER_COMMENT_BODY = 'SET_USER_COMMENT_BODY';
export var SET_USER_COMMENT_DISPLAY_NAME = 'SET_USER_COMMENT_DISPLAY_NAME';
export var SET_USER_COMMENT_EMAIL = 'SET_USER_COMMENT_EMAIL';
export var SET_USER_COMMENT_RATING = 'SET_USER_COMMENT_RATING'; // ------------------------------------
// Actions
// ------------------------------------

export var commentsLoaded = createAction(COMMENTS_LOADED, function (id, page, comments, pages) {
  return {
    id: id,
    page: page,
    comments: comments,
    pages: pages
  };
});
var commentsLoading = createAction(COMMENTS_LOADING, function (id, page) {
  return {
    id: id,
    page: page
  };
});
var commentPublishing = createAction(COMMENT_PUBLISHING, function (id) {
  return {
    id: id
  };
});
var commentPublished = createAction(COMMENT_PUBLISHED, function (id) {
  return {
    id: id
  };
});
var commentPublishFailed = createAction(COMMENT_PUBLISH_FAILED, function (id, error) {
  return {
    id: id,
    error: error
  };
});
export var clearCommentPublishError = createAction(CLEAR_COMMENT_PUBLISH_ERROR);
var commentFlagging = createAction(COMMENT_FLAGGING, function (uuid) {
  return {
    uuid: uuid
  };
});
var commentFlagged = createAction(COMMENT_FLAGGED, function (uuid) {
  return {
    uuid: uuid
  };
});
var commentFlaggedFailed = createAction(COMMENT_FLAGGED_FAILED, function (uuid, error) {
  return {
    uuid: uuid,
    error: error
  };
});
export var setUserCommentBody = createAction(SET_USER_COMMENT_BODY, function (body) {
  return {
    body: body
  };
});
export var setUserCommentDisplayName = createAction(SET_USER_COMMENT_DISPLAY_NAME, function (displayName) {
  return {
    displayName: displayName
  };
});
export var setUserCommentEmail = createAction(SET_USER_COMMENT_EMAIL, function (email) {
  return {
    email: email
  };
});
export var setUserCommentRating = createAction(SET_USER_COMMENT_RATING, function (rating) {
  return {
    rating: rating
  };
});
export var loadComments = function loadComments(id) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  return function (dispatch, getState) {
    dispatch(commentsLoading(id, page));
    var articleId = id && decodeURIComponent(id);
    var source = null;
    var fCols = [];

    if (articleId) {
      articleId = getGlobalId(articleId);
      source = getSource(articleId.split('_')[0]);
      fCols = [{
        name: 'article_id',
        value: articleId,
        logicalOperator: 'AND'
      }, {
        name: 'moderated',
        value: 'false',
        logicalOperator: 'AND'
      }, {
        name: 'datasource_data_index',
        value: source.dataIndex,
        logicalOperator: 'AND'
      }];
    }

    var params = {
      filter: {
        filterColumns: fCols,
        sortColumns: [{
          name: 'create_date',
          sortDesc: true
        }]
      },
      limit: pageSize,
      start: (page - 1) * pageSize
    };
    fetch(instanceUrl() + 'WebServices/articleComments/Comment.asmx/Read', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(params)
    }).then(function (res) {
      return res.json();
    }).then(function (res) {
      res = res.d;
      dispatch(commentsLoaded(id, page, res.success && res.records, res.total ? Math.ceil(res.total / pageSize) : 0));
    }).catch(function (e) {
      return dispatch(commentsLoaded(id, page, undefined));
    });
  };
};
var clearPublishErrorDelay = 5000;
var clearPublishErrorTimeout = 0;
export var publishComment = function publishComment(captcha) {
  return function (dispatch, getState) {
    var state = getState();
    var id = state.comments.articleId;
    var _state$comments$userC = state.comments.userComment,
        comment = _state$comments$userC.comment,
        displayName = _state$comments$userC.displayName,
        email = _state$comments$userC.email,
        rating = _state$comments$userC.rating;
    dispatch(commentPublishing(id));

    if (clearPublishErrorTimeout) {
      clearTimeout(clearPublishErrorTimeout);
      clearPublishErrorTimeout = 0;
    }

    var article = state.articles.articles[id];
    var title = article.properties.title;
    var geom = 'POINT(' + article.geometry.coordinates[0] + ' ' + article.geometry.coordinates[1] + ')';
    var articleId = decodeURIComponent(id);
    var globalId = getGlobalId(articleId);
    var source = getSource(articleId.split('_')[0]);
    var params = {
      captcha: captcha,
      data: {
        article_id: globalId,
        datasource_data_index: source ? source.dataIndex : null,
        title: title,
        geom: geom,
        comment: comment,
        display_name: displayName,
        email: email,
        rating: rating
      }
    };
    fetch(instanceUrl() + 'WebServices/articleComments/Comment.asmx/Save', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(params)
    }).then(function (res) {
      return res.json();
    }).then(function (res) {
      res = res.d;

      if (res.success) {
        dispatch(commentPublished(id));
        dispatch(loadComments(id));
      } else {
        dispatch(commentPublishFailed(id, res.exception));
        clearPublishErrorTimeout = setTimeout(function () {
          return dispatch(clearCommentPublishError());
        }, clearPublishErrorDelay);
      }
    }).catch(function (e) {
      console.warn('Publish failed', e);
      dispatch(commentPublishFailed(id, e));
      clearPublishErrorTimeout = setTimeout(function () {
        return dispatch(clearCommentPublishError());
      }, clearPublishErrorDelay);
    });
  };
};
export var flagComment = function flagComment(uuid) {
  return function (dispatch, getState) {
    dispatch(commentFlagging(uuid));
    var params = {
      uuid: uuid
    };
    fetch(instanceUrl() + 'WebServices/articleComments/Comment.asmx/flagComment', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(params)
    }).then(function (res) {
      return res.json();
    }).then(function (res) {
      res = res.d;

      if (res.success) {
        dispatch(commentFlagged(uuid));
      } else {
        dispatch(commentFlaggedFailed(uuid, res.exception));
      }
    }).catch(function (e) {
      console.warn('Comment flagged failed', e);
      dispatch(commentPublishFailed(uuid, e));
    });
  };
};
export var actions = {
  loadComments: loadComments,
  publishComment: publishComment,
  clearCommentPublishError: clearCommentPublishError,
  setUserCommentBody: setUserCommentBody,
  setUserCommentDisplayName: setUserCommentDisplayName,
  setUserCommentEmail: setUserCommentEmail,
  setUserCommentRating: setUserCommentRating,
  flagComment: flagComment
};

var parseDate = function parseDate(date) {
  try {
    return new Date(parseInt(date.match(/.Date\((\d+)\)./)[1], 10));
  } catch (ex) {
    return null;
  }
}; // ------------------------------------
// Reducer
// ------------------------------------


export default handleActions({
  COMMENTS_LOADED: function COMMENTS_LOADED(state, _ref) {
    var payload = _ref.payload;

    if (payload.comments) {
      var comments = payload.comments.map(function (data) {
        var create_date = data.create_date,
            display_name = data.display_name,
            comment = data.comment,
            uuid = data.uuid,
            white_listed = data.white_listed,
            article_id = data.article_id,
            title = data.title,
            datasource_data_index = data.datasource_data_index,
            rating = data.rating;
        return {
          create_date: parseDate(create_date),
          displayName: display_name,
          comment: comment,
          uuid: uuid,
          white_listed: white_listed,
          article_id: article_id,
          title: title,
          datasource_data_index: datasource_data_index,
          rating: rating
        };
      });
      return Object.assign({}, state, {
        loading: false,
        articleId: payload.id,
        page: payload.page,
        pages: payload.pages,
        comments: comments
      });
    } else {
      return Object.assign({}, state, {
        loading: false
      });
    }
  },
  COMMENTS_LOADING: function COMMENTS_LOADING(state, _ref2) {
    var payload = _ref2.payload;
    return Object.assign({}, state, {
      loading: true,
      articleId: payload.id,
      page: payload.page
    });
  },
  SET_USER_COMMENT_BODY: function SET_USER_COMMENT_BODY(state, _ref3) {
    var payload = _ref3.payload;
    var body = payload.body;
    return Object.assign({}, state, {
      userComment: Object.assign({}, state.userComment, {
        comment: body
      })
    });
  },
  SET_USER_COMMENT_DISPLAY_NAME: function SET_USER_COMMENT_DISPLAY_NAME(state, _ref4) {
    var payload = _ref4.payload;
    var displayName = payload.displayName;
    return Object.assign({}, state, {
      userComment: Object.assign({}, state.userComment, {
        displayName: displayName
      })
    });
  },
  SET_USER_COMMENT_EMAIL: function SET_USER_COMMENT_EMAIL(state, _ref5) {
    var payload = _ref5.payload;
    var email = payload.email;
    return Object.assign({}, state, {
      userComment: Object.assign({}, state.userComment, {
        email: email
      })
    });
  },
  SET_USER_COMMENT_RATING: function SET_USER_COMMENT_RATING(state, _ref6) {
    var payload = _ref6.payload;
    var rating = payload.rating;
    return Object.assign({}, state, {
      userComment: Object.assign({}, state.userComment, {
        rating: rating
      })
    });
  },
  CLEAR_COMMENT_PUBLISH_ERROR: function CLEAR_COMMENT_PUBLISH_ERROR(state) {
    return Object.assign({}, state, {
      publishError: false
    });
  },
  COMMENT_PUBLISHING: function COMMENT_PUBLISHING(state, _ref7) {
    var payload = _ref7.payload;
    return Object.assign({}, state, {
      publishing: true,
      publishError: false
    });
  },
  COMMENT_PUBLISHED: function COMMENT_PUBLISHED(state, _ref8) {
    var payload = _ref8.payload;
    return Object.assign({}, state, {
      publishing: false,
      userComment: Object.assign({}, state.userComment, {
        comment: ''
      })
    });
  },
  COMMENT_PUBLISH_FAILED: function COMMENT_PUBLISH_FAILED(state, _ref9) {
    var payload = _ref9.payload;
    return Object.assign({}, state, {
      publishing: false,
      publishError: true
    });
  },
  COMMENT_FLAGGING: function COMMENT_FLAGGING(state, _ref10) {
    var payload = _ref10.payload;
    var flagging = [payload.uuid].concat(state.flagging);
    return Object.assign({}, state, {
      flagging: flagging,
      flaggingError: false
    });
  },
  COMMENT_FLAGGED: function COMMENT_FLAGGED(state, _ref11) {
    var payload = _ref11.payload;
    var idx = state.flagging.indexOf(payload.uuid);
    var flagging = state.flagging.slice(0, idx).concat(state.flagging.slice(idx + 1));
    var flagged = [payload.uuid].concat(state.flagged);
    return Object.assign({}, state, {
      flagging: flagging,
      flagged: flagged
    });
  },
  COMMENT_FLAGGED_FAILED: function COMMENT_FLAGGED_FAILED(state, _ref12) {
    var payload = _ref12.payload;
    var idx = state.flagging.indexOf(payload.uuid);
    var flagging = state.flagging.slice(0, idx).concat(state.flagging.slice(idx + 1));
    return Object.assign({}, state, {
      flagging: flagging,
      flaggingError: true
    });
  }
}, {
  loading: false,
  publishing: false,
  publishError: false,
  flagging: [],
  flagged: [],
  flaggingError: false,
  articleId: '',
  page: 1,
  pages: 0,
  comments: [],
  userComment: {
    comment: '',
    displayName: '',
    email: '',
    rating: undefined
  }
});